/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CannabisLicenseHelper from '../../../helpers/features/CannabisLicensesHelper';

function DataPreview({
  label,
  data,
  addressLineOne,
  isAddress,
  onClickPreview,
  isLicenseDetails,
  isNote,
  isDate,
}) {
  const showData = () => {
    if (isAddress) {
      return <p onClick={onClickPreview}>{addressLineOne}</p>;
    }
    if (isDate && data !== CannabisLicenseHelper.NO_VALUES) {
      return <p onClick={onClickPreview}>{moment(data).format('MM/DD/YYYY')}</p>;
    }
    if (isLicenseDetails || isNote) {
      return <p dangerouslySetInnerHTML={{ __html: data }} />;
    }
    return <p onClick={onClickPreview}>{data}</p>;
  };

  return (
    <div className="modal-content-item">
      <b>{label}</b>
      {showData()}
    </div>
  );
}

DataPreview.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  addressLineOne: PropTypes.string,
  isAddress: PropTypes.bool,
  isLicenseDetails: PropTypes.bool,
  onClickPreview: PropTypes.func,
  isNote: PropTypes.bool,
};

DataPreview.defaultProps = {
  isAddress: false,
  isLicenseDetails: false,
  addressLineOne: '',
  isNote: false,
  onClickPreview: () => {},
};

export default DataPreview;
